import React from 'react'
import { useStep5Props } from './types'
import { wrap } from '../../../utils/globalUtils'
import useStep5 from './hooks/useStep5'
import Step5View from './views/Step5View'

const Step5: React.FC<useStep5Props> = wrap(Step5View, useStep5)
export default Step5
